import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TableGrades } from "./components/TableGrades";
import { CatalogGrade } from "@/shared/models/CatalogGrade";
import { getCatalogGrades } from "@/shared/repositories/CatalogGradeRepository";

type useCatalogGradesProps = {
	onError?: (error: Error) => void;
};

export const useCatalogGrades = ({ onError }: useCatalogGradesProps) => {
	return useQuery<CatalogGrade[], Error>({
		queryKey: ["catalogGrades"],
		queryFn: () => getCatalogGrades(),
		onError: onError,
	});
};

export const CatalogGradesPage = () => {
	return (
		<>
			<HelmetDexteel title="Grades - Configurations" />
			<TableGrades />
		</>
	);
};
